import React from 'react'
import { useTheme } from '../../hooks/useTheme'

export const ThemeToggle: React.FC = () => {
  const { toggleTheme, getThemeIcon, getThemeLabel } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className="btn btn-secondary flex items-center space-x-2"
      title={`テーマ切り替え (現在: ${getThemeLabel()})`}
    >
      <span className="text-lg">{getThemeIcon()}</span>
      <span className="hidden sm:inline">{getThemeLabel()}</span>
    </button>
  )
} 